import React from 'react'
import { TypeComponentTable } from '@lib/types/component-table'
import { ContentProps } from '../renderer'
import { TableView } from './table-view/table-view'
import { isTable } from './utils'

export const TableComponent: React.FC<ContentProps<TypeComponentTable>> = ({ structure }) => {
  const table = structure.fields.content.content.find(isTable)
  if (!table) {
    return null
  }

  return (
    <TableView
      table={table}
      firstRowAsHeader={structure.fields.firstRowAsHeader}
      primaryHeader={structure.fields.primaryHeader}
      firstColumnAsHeader={structure.fields.firstColumnAsHeader}
      zebraStriping={structure.fields.zebraStriping}
      headerCellConfig={{
        font: structure.fields.headerFontSize,
        verticalAlignment: structure.fields.headerVerticalAlignment,
        horizontalAlignment: structure.fields.headerHorizontalAlignment,
      }}
      cellConfig={{
        font: structure.fields.fontSize,
        verticalAlignment: structure.fields.verticalAlignment,
        horizontalAlignment: structure.fields.horizontalAlignment,
      }}
    />
  )
}
